export default [
  {
    name: 'High Level Update',
    subtopics: [
      {
        name: 'Challenges or concerns since we met last?',
      },
      {
        name: 'Are there any blockers you want to discuss?',
      },
      {
        name: 'What are your top 3 priorities until we meet again?',
      },
    ],
  },
  {
    name: 'Working from home support',
    subtopics: [
      {
        name: 'How are you feeling about work recently?',
      },
      {
        name: 'Do you need anything else for your work from home set up?',
      },
      {
        name: 'Is there anything that might make communication easier?',
      },
    ],
  },
  {
    name: 'Career Development',
    subtopics: [
      {
        name: 'What are some ways I could better support you?',
      },
      {
        name: 'What skills do you want to work on?',
      },
      {
        name: 'What are your 6-12 month career goals? Are you progressing towards that?',
      },
    ],
  },
  {
    name: 'Relationship Development ',
    subtopics: [
      {
        name: 'How do you like to give and receive feedback?',
      },
      {
        name: 'What do you like to do in your free time?',
      },
      {
        name: 'What’s something interesting you’ve accomplished that most people don’t know?',
      },
    ],
  },
];
